import { render, staticRenderFns } from "./AddBank.vue?vue&type=template&id=35b7e4dd"
import script from "./AddBank.vue?vue&type=script&lang=js"
export * from "./AddBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports